import { render, staticRenderFns } from "./jzqxSet.vue?vue&type=template&id=79960061&scoped=true&"
import script from "./jzqxSet.vue?vue&type=script&lang=js&"
export * from "./jzqxSet.vue?vue&type=script&lang=js&"
import style0 from "./jzqxSet.vue?vue&type=style&index=0&id=79960061&prod&lang=scss&scoped=true&"
import style1 from "./jzqxSet.vue?vue&type=style&index=1&id=79960061&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79960061",
  null
  
)

export default component.exports